import React, { Component } from 'react';
// @material-ui/core components
import { withStyles } from '@material-ui/core/styles';
// core components
import { Table, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { addMenu } from '../../store/actions/admin/Admin';
import CardHeader from '../../components/Card/CardHeader.js';
import CardBody from '../../components/Card/CardBody.js';
import CardFooter from '../../components/Card/CardFooter.js';
import Grid from '@material-ui/core/Grid';
import Textsms from '@material-ui/icons/Textsms';
import LocalDining from '@material-ui/icons/LocalDining';
import MonetizationOn from '@material-ui/icons/MonetizationOn';
import {
  getSuperCategory as getAllCategoryList,
  getAllSubCategory,
  getAllCategory as getCategoryList,
  upload
} from '../../store/actions/vendor/Vendor';
import GridItem from '../../components/Grid/GridItem.js';
import GridContainer from '../../components/Grid/GridContainer.js';
import CustomInput from '../../components/CustomInput/CustomInput.js';
import CustomInputWithIcons from '../../components/CustomInput/CustomInputWithIcons.js';
import {
  primaryColor,
  dangerColor,
  successColor,
  grayColor,
  defaultFont
} from '../../assets/jss/material-dashboard-react.js';

const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  },
  underline: {
    '&:hover:not($disabled):before,&:before': {
      borderColor: grayColor[4] + ' !important',
      borderWidth: '1px !important'
    },
    '&:after': {
      borderColor: primaryColor[0]
    }
  },
  underlineError: {
    '&:after': {
      borderColor: dangerColor[0]
    }
  },
  underlineSuccess: {
    '&:after': {
      borderColor: successColor[0]
    }
  },
  labelRoot: {
    ...defaultFont,
    color: grayColor[3] + ' !important',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '1.42857',
    letterSpacing: 'unset'
  },
  labelRootError: {
    color: dangerColor[0]
  },
  labelRootSuccess: {
    color: successColor[0]
  },
  feedback: {
    position: 'absolute',
    top: '18px',
    right: '0',
    zIndex: '2',
    display: 'block',
    width: '24px',
    height: '24px',
    textAlign: 'center',
    pointerEvents: 'none'
  },
  marginTop: {
    marginTop: '16px'
  },
  formControl: {
    paddingBottom: '10px',
    margin: '27px 0 0 0',
    position: 'relative',
    verticalAlign: 'unset'
  }
};

class AddMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      imageUploadMessage: '',
      valueUserLoginId: 'sdad',
      menu: {
        superCategoryId: '',
        categoryId: '',
        subCategoryId: '',
        name: '',
        description: '',
        price: '',
        image: ''
      }
    };
  }

  componentDidMount() {
    this.props.getAllCategoryList();
    this.setState({
      valueUserLoginId: localStorage.getItem('uid') || ''
    });
    this.setSupercategoryToDefault();
  }

  onChange = (event) => {
    let menu = this.state.menu;
    menu[event.target.name] = event.target.value;

    this.setState({
      menu
    });
  };
  setSupercategoryToDefault = (event) => {
    setTimeout(() => {
      this.setState((prevState) => ({
        menu: {
          ...prevState.menu,
          superCategoryId:
            this.props.superCategories[0] !== undefined
              ? this.props.superCategories[0].id
              : 'none'
        }
      }));
      this.props.getCategoryList(this.state.menu.superCategoryId);
    }, 6500);
  };
  onChangeSelect = (event) => {
    let menu = this.state.menu;
    menu[event.target.name] = event.target.value;

    this.setState({
      menu
    });
    this.props.getCategoryList(this.state.menu.superCategoryId);
    setTimeout(() => {
      this.props.categories[0] === undefined
        ? alert(
            'Please add a category first so that you can add menu using this super-category.'
          )
        : this.setState((prevState) => ({
            menu: {
              ...prevState.menu,
              categoryId:
                this.props.categories[0] !== undefined
                  ? this.props.categories[0].id
                  : 'none'
            }
          }));
    }, 4000);
  };
  handleChange = (selectedOption) => {
    this.setState({ selectedOption }, () =>
      console.log(`Option selected:`, this.state.selectedOption)
    );
  };
  onUpload = (event) => {
    this.setState({
      imageUploadMessage: 'Uploading the file, please wait...'
    });

    let data = new FormData();
    data.append('files', event.target.files[0]);

    // Upload image
    this.props
      .upload(data)
      .then((response) => {
        if (response.status === 201) {
          this.setState({
            imageUploadMessage: 'File uploaded successfully.'
          });
          let menu = this.state.menu;
          menu.image = `${response.data.uploads[0].path}`;
          this.setState({
            menu
          });
        } else {
          this.setState({
            imageUploadMessage: 'Please, try Again'
          });
        }
      })
      .catch((error) => {
        this.setState({
          imageUploadMessage:
            'An error occurred while executing the query. Please try Again'
        });
      })
      .then(() => {
        console.log('Image uploaded');
      });
  };
  onChangeSelect2 = (event) => {
    let menu = this.state.menu;
    menu[event.target.name] = event.target.value;

    this.setState({
      menu
    });
    this.props.getAllSubCategory(this.state.menu.categoryId);
    setTimeout(() => {
      this.props.subCategories[0] === undefined
        ? alert(
            'Please add a subcategory first so that you can add menu using this category.'
          )
        : this.setState((prevState) => ({
            menu: {
              ...prevState.menu,
              subCategoryId:
                this.props.subCategories[0] !== undefined
                  ? this.props.subCategories[0].id
                  : 'none'
            }
          }));
    }, 3000);
  };
  onSubmit = (event) => {
    event.preventDefault();
    // Update superCategoryDetail
    this.props.addMenu(this.state.menu);
    setTimeout(() => {
      this.props.history.push(
        '/vendor/menus/vendor/' + this.state.valueUserLoginId
      );
    }, 3000);
  };

  render() {
    const { classes } = this.props;
    return (
      <>
        <CardHeader color="primary">
          <h4 className={classes.cardTitleWhite}>Add a Menu</h4>
          <p className={classes.cardCategoryWhite}>
            When choosing icon, PNG images would be better over JPG or imap
          </p>
        </CardHeader>
        <CardBody>
          <br />
          <GridContainer>
            <GridItem xs={12} sm={12} md={3}>
              <div className={classes.formControl}>
                <Grid container spacing={1} alignItems="flex-end">
                  <Grid item>
                    <LocalDining style={{ color: '#00000090' }} />
                  </Grid>
                  <Grid item>
                    <CustomInputWithIcons
                      labelText="Menu Name"
                      value={this.state.menu.name}
                      onChange={this.onChange}
                      name="name"
                      id="name"
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <div className={classes.formControl}>
                <Grid container spacing={1} alignItems="flex-end">
                  <Grid item>
                    <MonetizationOn style={{ color: '#00000090' }} />
                  </Grid>
                  <Grid item>
                    <CustomInputWithIcons
                      labelText="Menu Price"
                      value={this.state.menu.price}
                      onChange={this.onChange}
                      name="price"
                      id="price"
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={3} style={{ marginTop: '-34px' }}>
              <div className={classes.formControl}>
                <Grid container spacing={1} alignItems="flex-end">
                  <Grid item></Grid>
                  <Grid item>
                    <CustomInput
                      labelText="Menu Image"
                      id="image"
                      type="file"
                      name="image"
                      accept="image/png, image/jpeg, image/jpg"
                      onChange={this.onUpload}
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                    <br />
                    <p style={{ color: '#000' }}>
                      {this.state.imageUploadMessage}
                    </p>
                  </Grid>
                </Grid>
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <select
                fullWidth={true}
                required="required"
                name="superCategoryId"
                id="inputState"
                className="form-control"
                value={this.state.menu.superCategoryId}
                onChange={this.onChangeSelect}
                style={{ marginTop: '2.5em' }}
              >
                {this.props.superCategories.length > 0 ? (
                  this.props.superCategories.map((type) => (
                    <option value={type.id} key={type.id}>
                      {type.name}
                    </option>
                  ))
                ) : (
                  <option disabled="disabled" selected="selected">
                    Select Super-Category
                  </option>
                )}
              </select>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <select
                fullWidth={true}
                required="required"
                name="categoryId"
                id="inputState"
                className="form-control"
                value={this.state.menu.categoryId}
                onChange={this.onChangeSelect2}
                style={{ marginTop: '2.5em' }}
              >
                {this.props.categories.length > 0 ? (
                  this.props.categories.map((type) => (
                    <option value={type.id} key={type.id}>
                      {type.name}
                    </option>
                  ))
                ) : (
                  <option disabled="disabled" selected="selected">
                    Select Category
                  </option>
                )}
              </select>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <select
                fullWidth={true}
                required="required"
                name="subCategoryId"
                id="inputState"
                className="form-control"
                value={this.state.menu.subCategoryId}
                onChange={this.onChangeSelect2}
                style={{ marginTop: '2.5em' }}
              >
                {this.props.subCategories.length > 0 ? (
                  this.props.subCategories.map((type) => (
                    <option value={type.id} key={type.id}>
                      {type.name}
                    </option>
                  ))
                ) : (
                  <option disabled="disabled" selected="selected">
                    Select sub-category
                  </option>
                )}
              </select>
            </GridItem>
            <GridItem xs={12} sm={12} md={9}>
              <div className={classes.formControl}>
                <Grid container spacing={3} alignItems="flex-end">
                  <Grid item>
                    <Textsms style={{ color: '#00000090' }} />
                  </Grid>
                  <Grid item>
                    <CustomInputWithIcons
                      labelText="Menu description"
                      id="description"
                      value={this.state.menu.description}
                      name="description"
                      onChange={this.onChange}
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            </GridItem>
          </GridContainer>
        </CardBody>
        <CardFooter>
          <Button
            type="submit"
            onClick={this.onSubmit}
            style={{
              color: '#fff',
              backgroundColor: '#9c27b0',
              boxShadow:
                '0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)'
            }}
          >
            +Add Menu
          </Button>
        </CardFooter>
        <br /> <br />
        <Table hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Icon</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>1</th>
              <td>{this.state.menu.name}</td>
              <td>
                <img
                  src={this.state.menu.image}
                  style={{ height: '70px' }}
                  alt=""
                />
              </td>
            </tr>
          </tbody>
        </Table>
      </>
    );
  }
}

const mapStateWithProps = (state) => ({
  superCategories: state.vendor.superCategories,
  categories: state.vendor.categories,
  subCategories: state.vendor.subCategories
});
const mapDispatchWithProps = (dispatch) => {
  return {
    addMenu: (categoryData) => dispatch(addMenu(categoryData)),
    getAllCategoryList: () => dispatch(getAllCategoryList()),
    getCategoryList: (superCategoryId) =>
      dispatch(getCategoryList(superCategoryId)),
    getAllSubCategory: (categoryId) => dispatch(getAllSubCategory(categoryId)),
    upload: (data) => dispatch(upload(data))
  };
};

export default compose(
  connect(mapStateWithProps, mapDispatchWithProps),
  withStyles(styles)
)(AddMenu);
